var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimetrack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19C4.3 19 0 14.776 0 9.50371C0 4.23146 4.275 0.00371094 9.5 0C14.7 0 19 4.32723 19 9.5C19 14.7722 14.8 19 9.5 19ZM9.5 0.953711C4.8 0.953711 0.95 4.82832 0.95 9.50371C0.95 14.1791 4.8 18.1047 9.5 18.1047C14.2 18.1047 18.05 14.1791 18.05 9.50371C18.05 4.72884 14.2 0.953711 9.5 0.953711ZM13.5 13.5288C13.3 13.5288 13.2 13.4293 13.1 13.3298L9.2 9.45026C9.1 9.35078 9 9.15184 9 9.05236V2.08901C9 1.79058 9.2 1.49215 9.5 1.49215C9.8 1.49215 10 1.69111 10 2.08901V8.75393L13.9 12.6335C14.1 12.8325 14.1 13.1309 13.9 13.3298C13.7258 13.5032 13.6 13.5288 13.5 13.5288Z",
    fill: "#37474F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimetrack);
export default __webpack_public_path__ + "static/media/timetrack.3759787a17d94534cdb1af3f931b45e2.svg";
export { ForwardRef as ReactComponent };